import { Component } from '@angular/core';
import { ICellRendererParams } from 'ag-grid-community';
import { cloneDeep } from 'lodash';
@Component({
  selector: 'piqet-angular-grid-project-autocomplete',
  templateUrl: './grid-project-autocomplete.component.html',
  styleUrls: ['./grid-project-autocomplete.component.css'],
})
export class GridProjectAutocompleteComponent {
  keyword = 'name';
  params: any;
  supplier: any;
  setValue: any;

  refresh(params: ICellRendererParams<any, any>): boolean {
    return false;
  }
  agInit(params: ICellRendererParams<any, any>): void {
    this.params = params;
    this.supplier = this.params.supplier;
    this.setValue = this.params.data.conversionSupplierName;
  }

  updateValue(event: any) {
    this.params.data = cloneDeep(this.params.data);
    this.params.data.conversionSupplierId = event.id;
    this.params.data.conversionSupplierName = event.name;
    this.params.editData(this.params.data);
  }

  onClearSearch(event: any) {
    this.params.data = cloneDeep(this.params.data);
    this.params.data.conversionSupplierId = null;
    this.params.data.conversionSupplierName = '';
    this.params.editData(this.params.data);
  }
}
